import { useMutation, useQueryClient } from 'react-query';
import AIAssistantService, {
  SendFeedbackRequest,
  SendFeedbackResponse
} from 'services/hooks/ai-assistant-service';

interface UseSendFeedbackProps {
  onSuccess?: (
    response: SendFeedbackResponse,
    variables: { payload: SendFeedbackRequest; feedbackUuid?: string }
  ) => void;
  onError?: (error: Error) => void;
}

const useSendFeedback = ({ onSuccess, onError }: UseSendFeedbackProps) => {
  const queryClient = useQueryClient();

  const sendFeedbackMutation = useMutation(
    async ({ payload, feedbackUuid }: { payload: SendFeedbackRequest; feedbackUuid?: string }) => {
      const data = await AIAssistantService.SendFeedback(payload, feedbackUuid);
      return data;
    },
    {
      onSuccess: async (response, variables) => {
        await queryClient.invalidateQueries('chatSession');

        if (onSuccess) {
          onSuccess(response, variables);
        }
      },
      onError: async (error: Error) => {
        if (onError) {
          onError(error);
        }
      }
    }
  );

  return sendFeedbackMutation;
};

export default useSendFeedback;
